import { StandardDTO } from "../../../common/types/common.dto.types";

export const DOWNLOAD_STANDARD_QUESTION_TEMPLATE =
  "DOWNLOAD_STANDARD_QUESTION_TEMPLATE";

const standardQuestionTemplateSagaActions = {
  downloadStandardQuestionTemplate: (parameters: StandardDTO) => {
    return {
      type: DOWNLOAD_STANDARD_QUESTION_TEMPLATE,
      payload: parameters,
    };
  },
};

export default standardQuestionTemplateSagaActions;
